/**
 * Временная кастомизация «шапки/подвала» для отдельных авторов.
 *
 * На странице автора (`/author/:name`) и его КП (`/author/:name/kp`) вместо
 * логотипа «CHAPTER FOUR PRODUCTION» сверху и снизу показывается бренд автора.
 *
 * Чтобы убрать кастомизацию — удалите запись из объекта ниже (или очистите его).
 */
export const AUTHOR_BRAND_OVERRIDES: Record<string, string> = {
  nosorogrec: 'NOSOROG RECORDS',
}

const BRANDED_ROUTE_NAMES = new Set(['author', 'author-kp'])

export interface AuthorBrand {
  /** Текст, заменяющий логотип «CHAPTER FOUR PRODUCTION». */
  text: string
  /** Куда ведёт логотип — на страницу автора. */
  to: string
}

/**
 * Возвращает бренд (текст + ссылку на страницу автора) для замены логотипа,
 * либо null, если для текущего маршрута/автора кастомизации нет.
 */
export function getAuthorBrandOverride(
  routeName: unknown,
  params: Record<string, unknown> | undefined,
): AuthorBrand | null {
  if (typeof routeName !== 'string' || !BRANDED_ROUTE_NAMES.has(routeName)) return null
  const name = typeof params?.['name'] === 'string' ? (params['name'] as string) : ''
  const text = AUTHOR_BRAND_OVERRIDES[name]
  if (!text) return null
  return { text, to: `/author/${name}` }
}
